/*!
 * @Author: luoob
 * @Date: 2021-03-23 14:52:00
 * @Last Modified by: luoob
 * @Last Modified time: 2021-03-23 14:52:00
 * @Introduction: 机构舆情模块路由
 */
const EnterpriseHome = () => import('@/views/enterprise/index.vue')
const EnterpriseDetail = () => import('@/views/enterprise/_id.vue')
const EnterpriseCreate = () => import('@/views/enterprise/create.vue')
const KeywordExamine = () => import('@/views/enterprise/keyword/examine.vue')
const EnterpriseSettle = () => import('@/views/enterprise/settle/index.vue')
const EnterpriseSettleDetail = () => import('@/views/enterprise/settle/_id.vue')
const EnterpriseAuth = () => import('@/views/enterprise/auth/index.vue')
const EnterpriseAuthDetail = () => import('@/views/enterprise/auth/_id.vue')
const PrCertList = () => import('@/views/enterprise/pr/index.vue')
const PrCertDetail = () => import('@/views/enterprise/pr/_id.vue')
const InfoEditList = () => import('@/views/enterprise/info/list.vue')
const InfoEditDetail = () => import('@/views/enterprise/info/_id.vue')
const InterviewList = () => import('@/views/enterprise/interview/list.vue')
const InterviewDetail = () => import('@/views/enterprise/interview/_id.vue')
import Layout from '@/layout/index.vue'
import { RouteConfig } from 'vue-router'

const enterpriseRoute: RouteConfig = {
    path: '/enterprise',
    component: Layout,
    meta: {
        title: '机构舆情',
        icon: 'icon-fumianyuqing',
        alwaysShow: true                // will always show the root menu
    },
    children: [
        {
            path: '',
            component: EnterpriseHome,
            meta: {
                title: '机构列表'
            }
        },
        {
            path: 'keyword/examine',
            component: KeywordExamine,
            meta: {
                title: '关键词审核'
            }
        },
        {
            path: 'settle',
            component: EnterpriseSettle,
            meta: {
                title: '收录审核'
            }
        },
        {
            path: 'settle/:id',
            component: EnterpriseSettleDetail,
            meta: {
                title: '机构收录详情',
                hidden: true
            }
        },
        {
            path: 'auth',
            component: EnterpriseAuth,
            meta: {
                title: '认证审核'
            }
        },
        {
            path: 'auth/:id',
            component: EnterpriseAuthDetail,
            meta: {
                title: '机构认证详情',
                hidden: true
            }
        },
        {
            path: 'pr',
            component: PrCertList,
            meta: {
                title: '入驻审核'
            }
        },
        {
            path: 'info/list',
            component: InfoEditList,
            meta: {
                title: '资料修改审核'
            }
        },
        {
            path: 'interview/list',
            component: InterviewList,
            meta: {
                title: '采访列表'
            }
        },
        {
            path: 'interview/:id',
            component: InterviewDetail,
            meta: {
                title: '采访详情',
                hidden: true
            }
        },
        {
            path: 'info/:id',
            component: InfoEditDetail,
            meta: {
                title: '机构修改信息详情',
                hidden: true
            }
        },
        {
            path: 'pr/:id',
            component: PrCertDetail,
            meta: {
                title: 'pr入驻详情',
                hidden: true
            }
        },
        {
            path: 'create',
            component: EnterpriseCreate,
            meta: {
                title: '机构创建',
                hidden: true
            }
        },
        {
            path: ':id',
            component: EnterpriseDetail,
            meta: {
                title: '机构详情',
                hidden: true
            }
        },
        {
            path: '/'
        }
    ]
}


export default enterpriseRoute
